import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

function PageToreister() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Stack sx={{ backgroundColor: '#073a4b', py: 4 }} alignItems="center" justifyContent="center">
            <Stack alignItems="center" justifyContent="center" sx={{ my: 2 }}>
                <Typography 
                    variant={isMobile ? 'h5' : 'h4'} 
                    sx={{ color: "#fff", textAlign: "center", width: "100%", my: 2 }}
                >
                    طوب اليوم هي مأوى الغد
                </Typography>
            </Stack>

            <Stack 
                alignItems="center" 
                justifyContent="center" 
                direction={isMobile ? "column" : "row"} 
                sx={{ color: "#fff", mb: 2 }} 
                gap={2}
            >
                {[
                    { number: "+25", text: "عقار بحاجة دعم جزئي" },
                    { number: "+100", text: "متبرع" },
                    { number: "+12", text: "منزل تم دعمه" },
                    { number: "+12", text: "عقار متضرر بالكامل تم دعمه" }
                ].map((item, index) => (
                    <Box 
                        key={index} 
                        sx={{ 
                            textAlign: "center", 
                            display: 'flex', 
                            alignItems: 'center', 
                            flexDirection: "column", 
                            justifyContent: 'center' 
                        }}
                    >
                        <Typography variant='h5'>
                            {item.number}
                        </Typography>
                        <Typography variant='body1'>
                            {item.text}
                        </Typography>
                    </Box>
                ))}
            </Stack>

            <Stack 
                alignItems="center" 
                justifyContent="center" 
                gap={2} 
                direction={isMobile ? "column" : "row"}
            >
                <Link className='btnLinkRgister' to="/">الانضمام كمتبرع</Link>
                <Link className='btnLinkRgister' to="/login">أنا متضرر وأبحث عن دعم</Link>
            </Stack>
        </Stack>
    );
}

export default PageToreister;
